import { render, staticRenderFns } from "./IconDisclaimer.vue?vue&type=template&id=90e2f466"
import script from "./IconDisclaimer.vue?vue&type=script&lang=ts"
export * from "./IconDisclaimer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports